import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import './index.css';

import {withFirebase} from '../Firebase';

import * as ROUTES from '../../constants/routes';

const SignupPage = () => (
    <div>
        <h3 className="margin-left">Sign up for an account with Thakaa Admin</h3>
        <SignupForm />

    </div>
)

const INITIAL_STATE = {
    familyname: '',
    firstname: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
}

class SignupFormBase extends Component {
    constructor(props) {
        super(props);
        this.state = {...INITIAL_STATE}
    }

    onSubmit = event => {
        const {familyname, firstname, email, passwordOne} = this.state;

        event.preventDefault();

        this.props.firebase.doCreateUserWithEmailandPassword(email, passwordOne)
        .then(async authUser => {


            console.log(authUser.user.uid);
            await this.props.firebase.realUser(authUser.user.uid).set(
              {
                familyname,
                firstname,
                email,
              },
              { merge: true }
            );
        })
        .then( () => {
            this.setState({...INITIAL_STATE});
            this.props.history.push(ROUTES.HOME)
        })
        .catch(error => {
            this.setState({error});
        });

     
    };

    onChange = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    render() {
        const {
          familyname,
          firstname,
          email,
          passwordOne,
          passwordTwo,
          error,
        } = this.state;

        const isInvalid =
          passwordOne !== passwordTwo ||
          passwordOne === "" ||
          passwordTwo === "" ||
          email === "" ||
          familyname === "" ||
          firstname === "";

        return (
          <form className="margin-left" onSubmit={this.onSubmit}>
            <input
              className="bp3-input "
              name="firstname"
              value={firstname}
              onChange={this.onChange}
              type="text"
              placeholder="First Name"
            />
            <input
              className="bp3-input "
              name="familyname"
              value={familyname}
              onChange={this.onChange}
              type="text"
              placeholder="Family Name"
            />
            <input
              className="bp3-input"
              name="email"
              value={email}
              onChange={this.onChange}
              type="text"
              placeholder="Email"
            />
            <input
              className="bp3-input"
              name="passwordOne"
              value={passwordOne}
              onChange={this.onChange}
              type="password"
              placeholder="Password"
            />
            <input
              className="bp3-input"
              name="passwordTwo"
              value={passwordTwo}
              onChange={this.onChange}
              type="password"
              placeholder="Confirm Password"
            />

            <button
              className="bp3-button margin-bottom"
              disabled={isInvalid}
              type="submit"
            >
              Sign Up
            </button>

            {error && <p>{error.message}</p>}
          </form>
        );
    }
}

const SignUpLink = () => (
    <p>
        Don't have an account? <Link to={ROUTES.SIGN_UP}>SignUp</Link>
    </p>
);

export default SignupPage;

const SignupForm = compose(
    withRouter,
    withFirebase
) (SignupFormBase);



export {SignupForm, SignUpLink}